import { createSlice } from "@reduxjs/toolkit";
import {
  connectXAccount,
  createXPost,
  getXAuthToken,
  getXAuthUrl,
  getXPost,
} from "./thunk";

const initialState = {
  xData: [],
  xAuthData: [],
  xAuthTokenData: [],
  xLoading: false,
  error: null,
};

const xSlice = createSlice({
  name: "x",
  initialState,
  reducers: {
    resetXData: (state) => {
      state.xLoading = false;
      state.xData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ------------------------------------------------------Connect X
      .addCase(connectXAccount.pending, (state) => {
        state.xLoading = true;
        state.error = null;
      })
      .addCase(connectXAccount.fulfilled, (state, action) => {
        state.xLoading = false;
        state.xData = action.payload;
      })
      .addCase(connectXAccount.rejected, (state, action) => {
        state.xLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Create post
      .addCase(createXPost.pending, (state) => {
        state.xLoading = true;
        state.error = null;
      })
      .addCase(createXPost.fulfilled, (state, action) => {
        state.xLoading = false;
        state.xData = action.payload;
      })
      .addCase(createXPost.rejected, (state, action) => {
        state.xLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Get post
      .addCase(getXPost.pending, (state) => {
        state.xLoading = true;
        state.error = null;
      })
      .addCase(getXPost.fulfilled, (state, action) => {
        state.xLoading = false;
        state.xData = action.payload;
      })
      .addCase(getXPost.rejected, (state, action) => {
        state.xLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Get auth url
      .addCase(getXAuthUrl.pending, (state) => {
        state.xLoading = true;
        state.error = null;
      })
      .addCase(getXAuthUrl.fulfilled, (state, action) => {
        state.xLoading = false;
        state.xAuthData = action.payload;
      })
      .addCase(getXAuthUrl.rejected, (state, action) => {
        state.xLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Get auth token
      .addCase(getXAuthToken.pending, (state) => {
        state.xLoading = true;
        state.error = null;
      })
      .addCase(getXAuthToken.fulfilled, (state, action) => {
        state.xLoading = false;
        state.xAuthTokenData = action.payload;
      })
      .addCase(getXAuthToken.rejected, (state, action) => {
        state.xLoading = false;
        state.error = action.payload;
      })
  },
});

export const { resetXData } = xSlice.actions;
export default xSlice.reducer;
